// extracted by mini-css-extract-plugin
module.exports =  {"unit":"var(--ring-unit)","branchLabel":"PipelineBranchLabel__branchLabel--Yi","branchLabelName":"PipelineBranchLabel__branchLabelName--Bv"};